import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useOrgUpdate from '@opsbase/react-gql-hooks/organisation/useOrgUpdate';
import markdown from '@opsbase/react-markdown';
import AppPage from '@opsbase/web-app/AppPage';
import EditableList from '@opsbase/web-editablelist';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo } from 'react';
const customFields = [
    { key: 'customField0' },
    { key: 'customField1' },
    { key: 'customField2' },
    { key: 'customField3' },
    { key: 'customField4' },
    { key: 'customField5' },
    { key: 'customField6' },
    { key: 'customField7' },
    { key: 'customField8' },
    { key: 'customField9' },
];
export function SetupAssetCustomFieldsPage() {
    var _a;
    const self = useSelf();
    const { updateSettings } = useSelfActions();
    const { data: org } = useOrgFindById({ variables: { id: self.organisationId } });
    const updateOrg = useOrgUpdate();
    const fieldNames = (_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.assetCustomFieldNames;
    const mergedData = useMemo(() => org
        ? customFields.map(item => {
            var _a;
            return { ...item, label: (_a = fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames[item.key]) !== null && _a !== void 0 ? _a : '' };
        })
        : [], [fieldNames, org]);
    const handleChange = useCallback(options => {
        var _a;
        const assetCustomFieldNames = { ...((_a = org.settings.assetCustomFieldNames) !== null && _a !== void 0 ? _a : {}) };
        options.forEach(o => (assetCustomFieldNames[o.key] = o.label));
        const patch = {
            settings: {
                assetCustomFieldNames,
            },
        };
        updateOrg({
            id: org.id,
            patch,
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateOrg: {
                    __typename: 'Organisation',
                    ...org,
                    ...patch,
                },
            },
        })
            .then(updatedOrg => {
            updateSettings(updatedOrg.settings);
        })
            .catch(doNothing);
    }, [org, updateSettings, updateOrg]);
    return (React.createElement(AppPage, null,
        React.createElement(Vertical, { padding: true, style: { overflow: 'auto' } },
            React.createElement(Pane, { padding: true },
                React.createElement(Text, { variant: "h2" }, markdown(i18n.t('asset-custom-fields-label'))),
                React.createElement("div", { style: { width: 500 } },
                    React.createElement(EditableList, { autoSelectIdx: 0, items: mergedData, valueField: "label", idField: "key", onChange: handleChange }))))));
}
export default SetupAssetCustomFieldsPage;
